import { useState, useEffect } from 'react';

const useReverseGeocode = (location) => {
    const [address, setAddress] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAddress = async () => {
            if (!location?.latitude || !location?.longitude) {
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${location.latitude}&lon=${location.longitude}&zoom=10`
                );

                if (!response.ok) {
                    throw new Error('Failed to fetch address');
                }

                const data = await response.json();
                
                // Extraire la ville et le pays
                const city = data.address.city || 
                           data.address.town || 
                           data.address.village || 
                           data.address.suburb ||
                           data.address.county;
                           
                const country = data.address.country;

                if (city && country) {
                    setAddress(`${city}, ${country}`);
                } else {
                    setAddress(data.display_name.split(',').slice(0, 2).join(','));
                }
            } catch (err) {
                console.error('Error fetching address:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAddress();
    }, [location?.latitude, location?.longitude]);

    return { address, loading, error };
};

export default useReverseGeocode;
